import React, { useState } from 'react';
import {useStyles} from './TakisAccordion.styles';
import TakisButton from '../components/TakisButton';
import TakisSimpleText from './TakisSimpleText'

const TakisAccordion = ({body, openCTA, closeCTA, backCTA}) => {
    const classes = useStyles();

    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const handleAccordionClick = () => {
      setIsAccordionOpen(!isAccordionOpen);
    };
    const handleTopClick = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      setTimeout(()=> {
        const main = document.getElementById("main-content")
        if (main) {
          main.focus()
        }
      }, 800)
    };
    return (
    <>
        <div className={classes.button_container}>
            <TakisButton
                color="purpleButton"
                title={`${isAccordionOpen?closeCTA.title:openCTA.title}`}
                alt={`${isAccordionOpen?closeCTA.alt:openCTA.alt}`}
                ariaLabel={`${isAccordionOpen?closeCTA.ariaLabel:openCTA.ariaLabel}`}
                type='action'
                aria-controls={"accordion-id"}
                aria-expanded={isAccordionOpen}
                btnFunc={handleAccordionClick}
            />
        </div>
        <div
          className={`${classes.accordion_details} ${isAccordionOpen?'':classes.closed}`}
          id="accordion-id"
          >
        <TakisSimpleText paragraph={body}/>
            <div className={classes.button_container}>
                <TakisButton
                    color="purpleButton"
                    title={backCTA.title}
                    alt={backCTA.alt}
                    ariaLabel={backCTA.ariaLabel}
                    type='action'
                    btnFunc={handleTopClick}
                />
            </div>
        </div>
    </>
    );
  };

  export default TakisAccordion;
